import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import Button from '../button/index';
import { Download } from '../../helpers/icon-dictionary';
import FileUploader from '../file-uploader/index';
import messages from './messages';
import css from './index.scss';

const Upload = ({ isUploading, downloadingQuickUploadTemplate, handleOnDownloadTemplate, handleOnUploadClick, productName, intl }) => (
    <div>
        <div className={css.header}>
            <div className={css.title}>{intl.formatMessage(messages.header)}</div>
        </div>
        <div className={css.subTitle}>{intl.formatMessage(messages.subTitle)} {productName}</div>
        <div className={css.content}>
            <div className={css.contentWrapper}>
                <div className={css.contentLabel}>{intl.formatMessage(messages.contentLabel)} {productName}</div>
                <div><Button
                    containerClassName={css.downloadStudentRoll}
                    handleOnClick={handleOnDownloadTemplate}
                    icon={Download}
                    iconClassName={css.svgIconContainer}
                    label={intl.formatMessage(messages.downloadTemplate)}
                    loading={downloadingQuickUploadTemplate}
                    loadingLabel={intl.formatMessage(messages.download)} /></div>
                <div className={css.line} />
                <FileUploader handleOnUploadClick={handleOnUploadClick} isUploading={isUploading} />
            </div>
        </div>
    </div>
);

Upload.propTypes = {
    handleOnUploadClick: PropTypes.func,
    handleOnDownloadTemplate: PropTypes.func,
    downloadingQuickUploadTemplate: PropTypes.bool,
    isUploading: PropTypes.bool,
    productName: PropTypes.string,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(css)(Upload));



// WEBPACK FOOTER //
// ./app/components/quick-upload/index.js